import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import without from 'lodash/without';

import { sendRequestWithPromise } from 'zoomforth_zfutils/xhr_tools.js';
import InfoPanelRootUI from './info_panel_root_ui.jsx';
import ChooseFolderModal from '../views/media_library.choose_folder_modal.js';
import { confirm } from 'zoomforth_tools/modern_helpers.js';
import { makeFormModal } from 'zoomforth_tools/make_form_modal.js';
import { addNotification } from 'zoomforth_zf/appglobals/notification-system.js';

class InfoPanelRoot extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedItemModels: []
    };
    autobind(this);
  }

  componentDidMount() {
    this.props.currentFolder.on('change', this.forceUpdate, this);
    this.props.currentFolder.on('destroy', this.handleCurrentFolderDelete, this);
    this.bindModelEvents(this.state.selectedItemModels);
  }

  componentWillUnmount() {
    this.props.currentFolder.off(null, null, this);
    this.unbindModelEvents(this.state.selectedItemModels);
  }

  /**
    Method exposed as a public method for calling by parent.
    https://stackoverflow.com/questions/24841855/react-js-access-to-component-methods

    This is a necessary historical artifact but will hopefully
    go away someday
  */
  setItemModels(itemModels) {
    this.unbindModelEvents(this.state.selectedItemModels);
    this.bindModelEvents(itemModels);
    this.setState({
      selectedItemModels: itemModels
    });
  }

  bindModelEvents(itemModels) {

    forEach(itemModels, (item)=> {

      item.on('destroy', (item)=> {
        this.removeItemModel(item);
      }, this);

      item.on('change:parent_folder_id', (item)=> {
        if(!this.getIsSearching()) {
          this.removeItemModel(item);
        }
      }, this);

    });

    if (itemModels.length == 1) {
      itemModels[0].on('change', ()=> {
        this.forceUpdate();
      }, this);
    }
  }

  unbindModelEvents(itemModels) {
    forEach(itemModels, (item)=> {
      item.off(null, null, this);
    });
  }

  handleNavigateFolder(folderId) {
    this.props.navState.navigateToFolderId(folderId);
  }

  handleDeleteAssets() {
    var confirmed = confirm(
      'Really delete these assets? You won\'t be able to search for them ' +
      'again, but they will remain in any published pages.'
    );
    confirmed.done(()=> {

      forEach(this.state.selectedItemModels, (asset)=> {
        asset.destroy()

          .done(()=> {
            addNotification({ message:`Successfully deleted asset: "${asset.get('display_filename')}"` });
          });
      });

    });
  }

  handleCurrentFolderDelete() {
    this.props.navState.navigate({
      folder_id: this.props.currentFolder.get('parent_id')
    });
  }

  getIsSearching() {
    return this.props.navState.getIsSearching();
  }

  getItemPath() {
    var folders = [];
    var parentFolder;
    const itemModels = this.state.selectedItemModels;
    const currentFolder = this.props.currentFolder;
    if (itemModels.length) {
      parentFolder = currentFolder.collection.findWhere({
        id: itemModels[0].getFolderId()
      });
    } else if (currentFolder.get('parent_id')) {
      parentFolder = currentFolder.collection.findWhere({
        id: currentFolder.get('parent_id')
      });
    } else {
      parentFolder = currentFolder.collection.at(0);
    }
    folders = parentFolder.getParents();
    folders.push(parentFolder);
    return folders;
  }


  getItemPathAsFolderData() {
    return map(this.getItemPath(), (folder)=> ({
      name: folder.getName(),
      id: folder.id
    }));
  }

  removeItemModel(item) {
    this.unbindModelEvents([item]);

    this.setState((state)=> ({
      ...state,
      selectedItemModels: without(state.selectedItemModels, item)
    }));
  }


  handleMoveItems() {
    var me = this;
    var selectedItemType;
    var selectedModelId;
    
    if(this.state.selectedItemModels.length == 0) {
      selectedItemType = 'folder';
      selectedModelId = this.props.currentFolder.get('id');
    } else {
      selectedModelId = this.state.selectedItemModels[0].get('id');
      selectedItemType = this.state.selectedItemModels[0].getItemType();
    }
    var moveModal = new ChooseFolderModal({
      folderCollection: this.props.currentFolder.collection,
      navState: this.props.navState,
      selectedItemType: selectedItemType,
      selectedItemId: selectedModelId
    });
    moveModal.show().done((folderId)=> {
      moveModal.once('hidden', ()=> {
        var iterator = this.state.selectedItemModels.length ? this.state.selectedItemModels : [me.currentFolder];
        forEach(iterator, function(itemModel){
          window.setTimeout(function(){
            itemModel.moveToFolder(folderId);
          }, 0);
        });
      });
    });
  }
    

  render() {

    const { selectedItemModels } = this.state;
    const { currentFolder, navState, onAssetExpand, onAssetReplace, onClearAssetSelection } = this.props;

    const isInSearchMode = navState.getIsSearching();

    return (
      <InfoPanelRootUI
        currentFolder={currentFolder}
        selectedItemModels={selectedItemModels}
        isInSearchMode={isInSearchMode}
        pathAsFolderData={this.getItemPathAsFolderData()}
        onAssetsDelete={this.handleDeleteAssets}
        onAssetReplace={onAssetReplace}
        onAssetExpand={onAssetExpand}
        onItemsMove={this.handleMoveItems}
        onFolderNavigate={this.handleNavigateFolder}
        onClearAssetSelection={onClearAssetSelection}
      />
    );
  }

}


InfoPanelRoot.propTypes = {
  currentFolder: PropTypes.object.isRequired,
  navState: PropTypes.object.isRequired, // navState model
  onAssetExpand: PropTypes.func.isRequired
};

export default InfoPanelRoot;